import {Component, Input, OnInit, OnChanges, SimpleChange, Output, EventEmitter} from '@angular/core';
import {Cours} from '../../cours.model';
import {FormationService, Question} from '../../../formation';
import {CandidatureFormationService} from '../../candidature-formation.service';
import {CoursDisponible} from '../../../cours-disponible/cours-disponible.model'  ;
import {TranslateService} from 'ng2-translate';
import {CasParticulierEI} from '../../../formation';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-cours-component',
    templateUrl: 'cours.component.html'
})
export class CoursComponent implements OnInit, OnChanges {

    @Input() cours: Cours;
    @Input() listeCoursDisponible: CoursDisponible[];
    @Output() coursChange: EventEmitter<Cours> = new EventEmitter();
    @Input() questionsChange: EventEmitter<Question[]>;
    @Input() index: number;
    @Input() isEditable: Boolean;
    @Input() candidatureFormationId: number;
    @Input() currentLang: string;
    @Input()  questions: Question[] ;

    private coursDisponible: CoursDisponible;
    public questionCoursCode: Question | undefined;
    public questionLibelleCours: Question | undefined;
    public questionEctsCours: Question | undefined;
    public QuestionClass = Question ;
    private aide: Question;

    constructor(public formationService: FormationService,
                public candidatureFormationService: CandidatureFormationService,
                private translate: TranslateService, private modalService: NgbModal) {
    }

    ngOnInit() {
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang);
        // this.constructionListeCoursGroupee();
        this.selectionDuCoursDisponible();
        this.majQuestion();
        this.questionsChange.subscribe(nouvelleQuestions => {
            this.questions = nouvelleQuestions ;
            this.majQuestion();
        }) ;
    }

    private majQuestion() {
        this.questionCoursCode = this.questions.find(
            question => question.reponseComplement != null && question.reponseComplement == CasParticulierEI.EI_QUESTION_COURS_CODE);
        this.questionLibelleCours = this.questions.find(
            question => question.reponseComplement != null && question.reponseComplement == CasParticulierEI.EI_QUESTION_COURS_LIBELLE);
        this.questionEctsCours = this.questions.find(
            question => question.reponseComplement != null && question.reponseComplement == CasParticulierEI.EI_QUESTION_COURS_ECTS);
    }

    private selectionDuCoursDisponible() {
        if (this.listeCoursDisponible != null && this.cours != null) {
            let listCoursDisponibleSelect = this.listeCoursDisponible.filter(coursDispo => coursDispo.cCours == this.cours.code);
            if (listCoursDisponibleSelect.length > 0) {
                this.coursDisponible = listCoursDisponibleSelect[0];
            }
        }
    }

    ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
        // this.constructionListeCoursGroupee();
        this.selectionDuCoursDisponible();
    }

    public onCoursChanged(codeCours: String) {

        let coursOk = false;
        if (codeCours != null && codeCours.length > 0 && this.listeCoursDisponible != null) {
            let coursSelect = this.listeCoursDisponible.filter(coursDispo => coursDispo.cCours == codeCours);
            if (coursSelect != null && coursSelect.length > 0) {
                this.coursDisponible = coursSelect[0];
                 this.cours.libelle = this.coursDisponible.llCours;
                this.cours.ects = this.coursDisponible.ects;
                this.cours.index = this.index;
                this.coursChange.emit(this.cours);
                coursOk = true;
            }
        }
        if (coursOk == false) {
            // this.coursDisponible = null;
            this.cours.libelle = '';
            this.cours.ects = 0;
            this.cours.index = -1;
            this.coursChange.emit(this.cours);
        }
    }

     openAide(questionModal, question) {
        this.aide = question;
        this.modalService.open(questionModal);
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/formation/international/cours.component.ts